import { render, staticRenderFns } from "./UmbracoForm.vue?vue&type=template&id=193df10c&"
import script from "./UmbracoForm.vue?vue&type=script&lang=js&"
export * from "./UmbracoForm.vue?vue&type=script&lang=js&"
import style0 from "./UmbracoForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports